module.exports = __webpack_public_path__ + "static/img/statusEdit.9dfd6a3a.svg";